// Rem Calc
export const remCalc = (px: number) => px / 16 + 'rem';
